// extracted by mini-css-extract-plugin
module.exports = {"container":"SideMenu_container__2bPyT","tabs":"SideMenu_tabs__3aD7q","resourceList":"SideMenu_resourceList__32jz2"};